import { hasWindow } from "@omni/utils/dom.utils";

import {
    PureAemComponent,
    registerComponent
} from "@/components/pureAemComponent";
import * as HeaderModule from "@/redux/modules/value/header/header.module";
import * as HeaderSelectors from "@/redux/modules/value/header/header.selectors";
import * as ProfileSidebarModule from "@/redux/modules/value/profileSidebar/profileSidebar.module";
import * as ProfileSidebarSelectors from "@/redux/modules/value/profileSidebar/profileSidebar.selectors";
import * as WishlistSidebarModule from "@/redux/modules/value/wishlistSidebar/wishlistSidebar.module";
import * as WishlistSidebarSelectors from "@/redux/modules/value/wishlistSidebar/wishlistSidebar.selectors";
import { TStore } from "@/redux/store.types";
import BreakpointService from "@/services/breakpoint.service";

class Navigation extends PureAemComponent {
    previousWidth: number;
    dispatch: TStore["dispatch"];

    constructor(element: HTMLElement) {
        super(element);

        this.previousWidth = window.innerWidth;

        this.dispatch = window.storeManager.dispatch;

        this.init();
    }

    init() {
        window.addEventListener("resize", this.onResize.bind(this));

        this.onResize();
    }

    onResize() {
        const state = window.storeManager.getState();
        const mobile = HeaderSelectors.isMobile(state);
        const flyoutActive = HeaderSelectors.isFlyoutActive(state);
        const wishlishtVisible =
            WishlistSidebarSelectors.isSidebarVisible(state);
        const profileActive =
            !!ProfileSidebarSelectors.getProfileSidebar(state)?.active;

        if (this.isMobile()) {
            if (!mobile || flyoutActive) {
                this.dispatch(
                    HeaderModule.update({ mobile: true, flyoutActive: false })
                );
            }

            if (this.isResizeHorizontal() && wishlishtVisible) {
                this.dispatch(WishlistSidebarModule.update({ visible: false }));
            }
        } else {
            if (mobile || !flyoutActive) {
                this.dispatch(
                    HeaderModule.update({ mobile: false, sidebarActive: false })
                );
            }

            if (!wishlishtVisible) {
                this.dispatch(WishlistSidebarModule.update({ visible: true }));
            }

            if (profileActive) {
                this.dispatch(ProfileSidebarModule.update({ active: false }));
            }
        }

        this.updateResizeDimensions();
    }

    updateResizeDimensions() {
        this.previousWidth = window.innerWidth;
    }

    isResizeVertical() {
        return this.previousWidth === window.innerWidth;
    }

    isResizeHorizontal() {
        return !this.isResizeVertical();
    }

    isMobile() {
        return !BreakpointService.matchesMinLg();
    }
}

const InitNavigation = () => {
    hasWindow() && registerComponent("header.navigation", Navigation);
};

export { InitNavigation };
